import { useState } from "react";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import FullPageLoader from "~/components/UI/FullPageLoader";
import { useCompanyAccountContext } from "~/context/companyAccountContext";
import { useUserContext } from "~/context/userContext";
import { RoleEnum } from "~/types/data/User.types";

import { routePaths } from "../routes";

export const SecondHandRoute = () => {
  const { userState } = useUserContext();
  const { companyAccount } = useCompanyAccountContext();
  const [isConnected, setIsConnected] = useState(false);
  const [hasSecondHandCompany, setHasSecondHandCompany] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const isAuthenticated =
    userState?.connected &&
    companyAccount.connected !== undefined &&
    (userState.role === RoleEnum.ADMIN || userState.role === RoleEnum.SELLER);

  const { loginRoute, dashboardRoute } = routePaths;

  useEffect(() => {
    if (userState && companyAccount.connected !== undefined) {
      if (isAuthenticated) {
        setIsConnected(userState.connected);
        setHasSecondHandCompany(!!companyAccount.secondHandCompany);
      }
      setIsLoading(false);
    }
  }, [userState?.connected, companyAccount.connected]);
  console.log("SecondHandRoute", hasSecondHandCompany);
  return (
    <>
      {isLoading ? (
        <FullPageLoader />
      ) : (
        <>
          {hasSecondHandCompany ? (
            <Outlet />
          ) : isConnected ? (
            <Navigate to={`/${dashboardRoute}`} />
          ) : (
            <Navigate to={`/${loginRoute}`} />
          )}
        </>
      )}
    </>
  );
};
